import { CircularProgress, MenuItem, Select } from '@material-ui/core'

import React from 'react'
import { useListTags } from '../hooks/useListTags'

interface ITagInput {
  disabled?: boolean
  tag: string
  setTag: (tag: string) => void
  error?: boolean
}

export const TagInput = (props: ITagInput) => {
  const { data, loading } = useListTags({
    input: {
      limit: 100
    }
  })

  return loading ? (
    <CircularProgress />
  ) : (
    <>
      <Select
        value={props.tag}
        onChange={e => props.setTag(e.target.value as string)}
        fullWidth
        variant='outlined'
        error={props.error}>
        <MenuItem value=''>Select A Tag</MenuItem>
        {data?.listNotificationTags.notificationTags
          ?.map(tag => ({
            id: tag.id,
            title: `${tag.tagGroup} | ${tag.title}`
          }))
          .sort((a, b) => a.title.localeCompare(b.title))
          .map(tag => (
            <MenuItem key={tag.id} value={tag.id}>
              {tag.title}
            </MenuItem>
          ))}
      </Select>
    </>
  )
}
